import qs from 'qs';
import axios from 'axios';
import {paramFilter} from '@/utils';
import {RESPONSE_RESULT} from '@/constant';
import {useLanguage} from '@/hooks';
import {ErrorMessage, NavigatorMessage, NoAuthMessage} from '@/models';

const instance = axios.create({
  withCredentials: true,
  baseURL: '/api/sso',
  headers: {
    'Content-Type': 'application/json',
  },
});

const { CSV } = RESPONSE_RESULT;

async function onResolve(response) {
  let {
    headers,
    data: responseData,
    config: { url, baseURL },
  } = response;

  if (headers['content-type']?.includes(CSV)) return response;

  // let { success, errorCode } = responseData;
  // if (success === false) {
  //   if (errorCode === 'LOGIN_NOT_ENABLED') {
  //     const { routerTo } = useRouter();
  //     removeToken();
  //     routerTo('/login');
  //   }
  //   throw createResponseErrorMessage(responseData);
  // }

  return responseData;
}

async function onReject(error = {}) {
  let errorData;

  const { code, message, response } = error;

  if (message === 'Network Error') {
    errorData = new ErrorMessage({ content: message });
  } else if (code === 'ECONNABORTED') {
    errorData = null; // ignore
  } else if (400 === response?.status) {
    errorData = createResponseErrorMessage(response.data);
  } else if (401 === response?.status) {
    errorData = new NoAuthMessage({ data: response });
  } else if (404 === response?.status) {
    errorData = new ErrorMessage({ content: '404 NotFound' });
  } else if ([500, 502, 503, 504].includes(response?.status)) {
    errorData = new NavigatorMessage({ path: '/error', type: 'replace', data: response });
  } else if (response?.data) {
    errorData = response.data;
  } else {
    errorData = new NavigatorMessage({ path: '/login', type: 'replace', data: response });
  }

  if (errorData) {
    throw errorData;
  }
}

instance.interceptors.response.use(onResolve, onReject);

export function $ssoFetch(url, params, strict = true) {
  if (strict) params = paramFilter(params);
  url = params ? `${url}?${qs.stringify(params)}` : url;
  return instance.get(url);
}

export function $ssoPost(url, data) {
  return instance.post(url, data);
}

export function $ssoPut(url, data) {
  return instance.put(url, data);
}

export function $delete(url, params) {
  return instance.delete(url, { params });
}

export function createResponseErrorMessage(responseData) {
  const { errorCode, errorParamMap } = responseData;
  const { te, t, PREFIX } = useLanguage();
  let content = te(errorCode, PREFIX.ERROR_CODE)
    ? t(errorCode, PREFIX.ERROR_CODE, errorParamMap)
    : t('serverUnavailable', PREFIX.ERROR);
  return new ErrorMessage({ content }, responseData);
}
